export default {"src":"/_next/static/media/personalized-service.91adec9c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};